<template>
    <div>
        <div>
            <van-notice-bar :scrollable="false">
                提示：请选择该套餐的体检人员。
            </van-notice-bar>
            <van-cell-group>
                <van-field label="姓名" placeholder="请选择" v-model="name" @click="sel"/>
                <van-field label="性别" v-model="sex" disabled/>
                <van-field label="联系电话" v-model="tel" disabled/>
                <van-field label="证件号码" v-model="no" disabled/>
                <van-field label="关系" v-model="relation" disabled/>
            </van-cell-group>
        </div>
        <div class="icons">
            <button type="button" class="cancle" @click="cancle">取消</button>
            <button type="button" @click="next">下一步</button>
        </div>
        <van-popup v-model="showPop" position="bottom">
            <ul class="name">
                <li v-for="(li,index) in names" :key="index" :class="{different:(li.GENDER!=comboSex&&comboType==2)}" @click="nameSel(li)">{{li.NAME}}</li>
            </ul>
        </van-popup>
    </div>
</template>

<script>
    import api from '@/fetch/api';
    import {
        mapGetters
    } from 'vuex';
    import {
        Dialog,
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                name: '',
                sex: '',
                tel: '',
                no: '',
                relation: '',
                showPop: false,
                type: '',
                names: [],
                INDIVIDUAL_ID: ''
            }
        },
        props: {
            actionType: Number,
            comboSex: Number,
            comboType: Number
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getType(vm)
            })
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo", "sexes"]),
        },
        methods: {
            getType(el) {
                this.type = el.$route.params.type;
            },
            sel() {
                this.showPop = true;
                 document.activeElement.blur();
            },
            nameSel(i) {
                console.log(i);
                console.log(this.comboSex);
                if (i.GENDER != this.comboSex && this.comboType == 2) {
                    Toast.fail('对不起，该套餐适合' + (this.comboSex == 0 ? '女' : '男') + '性');
                    return false;
                }
                // console.log(i);
                //  console.log(this.sexes);
                this.name = i.NAME;
                this.INDIVIDUAL_ID = i.INDIVIDUAL_ID;
                // this.sex = this.sexes.find(p => p.key == i.GENDER).value;
                this.sex = i.GENDER == 0 ? '女' : '男';
                this.tel = i.PHONE_NUM;
                this.no = i.IDNUMBER;
                this.relation = i.RELATIONNAME;
                this.showPop = false;
            },
            next() {
                if (this.INDIVIDUAL_ID) {
                    if (this.type == '1') {
                        this.$router.push({
                            path: '/user/survey/' + this.INDIVIDUAL_ID
                        });
                    } else if (this.type == '2') {
                        this.$router.push({
                            path: '/user/gudingtc/' + this.INDIVIDUAL_ID
                        });
                        // this.$emit('INDIVIDUAL',  this.INDIVIDUAL_ID );
                    } else {
                        let data = {
                            INDIVIDUAL_ID: this.INDIVIDUAL_ID,
                            ACTIONTYPE: this.actionType
                        }
                        this.$emit('INDIVIDUAL', data);
                    }
                    //data里的内容重新初始化
                    Object.assign(this.$data, this.$options.data());
                    this.bindNames();
                } else {
                    Toast.fail('请选择姓名');
                }
            },
            bindNames() {
                api.queryUser(this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                    this.names = re.data;
                })
            },
            cancle() {
                if (this.type != '')
                    this.$router.back(-1);
                else
                    this.$emit('INDIVIDUAL', '');
            }
        },
        created() {
            window.scroll(0, 0);
            this.bindNames();
        }
    }
</script>

<style scoped lang="less">
    .icons {
        text-align: center;
        margin-top: 2rem;
        i {
            color: #619534;
            font-size: 1.2rem;
        }
        button {
            margin: 0 1rem;
            background: inherit;
            background-color: #aacd06;
            box-sizing: border-box;
            border-width: 1px;
            border-style: solid;
            border-radius: 6px;
            box-shadow: none;
            text-align: center;
            font-size: 0.8em;
            height: 2.5rem;
            width: 30%;
            color: #fff;
            border-color: #aacd06; // position: absolute;
            // right: 2rem;
        }
        .cancle {
            color: #aacd06;
            border-color: #aacd06;
            background-color: #fff;
        }
    }
    .name {
        li {
            border-bottom: 1px solid #f0f0f0;
            line-height: 3rem;
            text-align: center;
        }
        li.different {
            color: #f0f0f0;
        }
        i {
            color: #999;
        }
        .active {
            color: #99C51D;
        }
        span {
            font-size: 18px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/personSel.vue